import styled from "styled-components";

const ButtonStyle = styled.button`
    border-radius: 20px;
    cursor: pointer;
    border: none;
    display: block;
    padding: 20px;
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 20px;
    width: 100%;
    
    background: #F0F1F5;
    color: #0A0F15;

    &:disabled {
        background-color: #919599;;
        cursor: default;
    }
`;

export default ButtonStyle;